import {z} from 'zod';
import {parseJsonCookie} from './parse-json-cookie.js';

export type LoginUserDetails = z.TypeOf<typeof LoginUserDetails>;

const LoginUserDetails = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  idToken: z.string(),
  uid: z.string(),
  organisationId: z.string().optional(),
  userId: z.string(),
  ecomAccessToken: z.string(),
});

export const loginUserDetailsCookieName = `smart-login_user_details`;

export function parseLoginUserDetailsCookie(
  cookieData: string,
): LoginUserDetails | undefined {
  return parseJsonCookie({
    cookieData,
    cookieName: loginUserDetailsCookieName,
    schema: LoginUserDetails,
  });
}
